<template>
  <qx-card-form title="结算">
    <section>
      <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
        labelWidth="120px"
      >
        <div slot="dispatchRecive" slot-scope="prop">
          <div v-show="prop.form.dispatchBalanceType === '2'">
            <el-input
              class="inputBox"
              v-model="otherFormData.dispatchReciveTime"
              placeholder="请输入"
            >
              <span slot="suffix" class="inputSlotText">天</span>
            </el-input>
          </div>
          <div v-show="prop.form.dispatchBalanceType === '3'">
            <el-input
              class="appendInputBox"
              v-model="otherFormData.dispatchReciveMonth"
              placeholder="请输入"
            >
              <span slot="suffix"
                >个月后
                <el-select
                  class="inputAppendSelect"
                  v-model="otherFormData.dispatchReciveTimeDay"
                  :clear="true"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in 31"
                    :key="item"
                    :label="item + '号'"
                    :value="item"
                  />
                </el-select>
              </span>
            </el-input>
          </div>
        </div>
        <div slot="dispatchCollection" slot-scope="prop">
          <div v-show="prop.form.dispatchBalanceType === '2'">
            <el-input
              class="inputBox"
              v-model="otherFormData.dispatchCollectionTime"
              placeholder="请输入"
            >
              <span slot="suffix" class="inputSlotText">天</span>
            </el-input>
          </div>
          <div v-show="prop.form.dispatchBalanceType === '3'">
            <el-input
              class="appendInputBox"
              v-model="otherFormData.dispatchCollectionMonth"
              placeholder="请输入"
            >
              <span slot="suffix"
                >个月后
                <el-select
                  class="inputAppendSelect"
                  v-model="otherFormData.dispatchCollectionTimeDay"
                  :clear="true"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in 31"
                    :key="item"
                    :label="item + '号'"
                    :value="item"
                  />
                </el-select>
              </span>
            </el-input>
          </div>
        </div>
      </qx-custom-form>
      <button @click="getDataTest" class="test-btn">测试提交参数</button>
    </section>
  </qx-card-form>
</template>

<script>
import {
  queryMemberBenefits,
} from 'api/operate';
export default {
  props: {
    dispatchBalanceTypeOptions: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      otherFormData: {
        dispatchReciveTime: '', // 回单期限天数
        dispatchReciveMonth: '', // 回单期限第几个月
        dispatchReciveTimeDay: '', // 回单期限第几号
        dispatchCollectionTime: '', // 收款期限天数
        dispatchCollectionMonth: '', // 收款期限第几个月
        dispatchCollectionTimeDay: '', // 收款期限第几号
      },
      baseForm: {
        dispatchBalanceTypeOptions: [],
        inline: true,
        form: [
          {
            label: '结算方式',
            value: 'dispatchBalanceType',
            type: 'select',
            width: '240px',
            default: '-1',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '回单期限',
            value: 'dispatchRecive',
            slot: true,
            hide: true,
          },
          {
            label: '付款期限',
            value: 'dispatchCollection',
            slot: true,
            hide: true,
          },
        ],
        rules: {
          // dispatchBalanceType: [ // 结算方式
          //   { required: true, message: '请选择结算方式', trigger: 'blur' },
          // ],
          // dispatchRecive: [ // 回单期限
          //   { validator: this.checkRecive, trigger: 'blur' },
          // ],
          // dispatchCollection: [ // 收款期限
          //   { validator: this.checkCollection, trigger: 'blur' },
          // ],
        },
      },
    };
  },
  watch: {
    dispatchBalanceTypeOptions (newVal) {
      this.baseForm.dispatchBalanceTypeOptions = newVal;
    },
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (options) {
      const dispatchBalanceTypeOptions = [
        { label: '请选择', value: '-1' },
        ...options.filter((item) => item.value !== '1'),
      ];
      this.baseForm.dispatchBalanceTypeOptions = dispatchBalanceTypeOptions;
      this.$refs.baseForm.setVal('dispatchBalanceType', dispatchBalanceTypeOptions[0].value);
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证回单期限
     */
    checkRecive (rule, value, call) {
      const dispatchBalanceType = this.$refs.baseForm.getVal('dispatchBalanceType');
      if ((dispatchBalanceType === '1' || dispatchBalanceType === '2') && !this.otherFormData.dispatchReciveTime) {
        call('请输入回单期限天数');
      } else if (dispatchBalanceType === '3' && (!this.otherFormData.dispatchReciveMonth || !this.otherFormData.dispatchReciveTimeDay)) {
        call('请输入回单期限天数');
      } else {
        call();
      }
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证收款期限
     */
    checkCollection (rule, value, call) {
      const dispatchBalanceType = this.$refs.baseForm.getVal('dispatchBalanceType');
      if (dispatchBalanceType === '2' && !this.otherFormData.dispatchCollectionTime) {
        call('请输入收款期限天数');
      } else if (dispatchBalanceType === '3' && (!this.otherFormData.dispatchCollectionMonth || !this.otherFormData.dispatchCollectionTimeDay)) {
        call('请输入收款期限天数');
      } else {
        call();
      }
    },
    handleLabelTypeChange () {
      const dispatchBalanceType = this.$refs.baseForm.getVal('dispatchBalanceType');
      // this.setFormHide();
      switch (dispatchBalanceType) {
        case '-1':
          this.setFormHide();
          break;
        case '2':
        case '3':
          this.setFormHide();
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['dispatchRecive', 'dispatchCollection'],
          });
          break;
        default:
          break;
      }

      // let isNotAuto = dispatchBalanceType === '1';
      // const tar = ['dispatchCollection'];
      // this.baseForm.form.forEach((item) => {
      //   if (tar.indexOf(item.value) !== -1) {
      //     item.hide = isNotAuto;
      //   }
      // });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        dispatchBalanceType: res.dispatchBalanceType,
        payWay: res.dispatchBalanceType,
        ...this.otherFormData,
      };
      return res;
    },

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        let dispatchInfo = {};
        formData = {
          dispatchBalanceType: formData.dispatchBalanceType,
          payWay: formData.dispatchBalanceType,
          ...this.otherFormData,
        };
        dispatchInfo = {
          ['dispatchInfo.dispatchBalanceData.balanceType']: formData.dispatchBalanceType,
          ['dispatchInfo.dispatchBalanceData.isCost']: true,
          ['dispatchInfo.dispatchBalanceData.reciveDay']: formData.dispatchReciveTimeDay,
          ['dispatchInfo.dispatchBalanceData.collectionDay']: formData.dispatchCollectionTimeDay,
          ['dispatchInfo.dispatchBalanceData.reciveTime']: formData.dispatchReciveTime,
          ['dispatchInfo.dispatchBalanceData.collectionTime']: formData.dispatchCollectionTime,
          ['dispatchInfo.dispatchBalanceData.reciveMonth']: formData.dispatchReciveMonth,
          ['dispatchInfo.dispatchBalanceData.collectionMonth']: formData.dispatchCollectionMonth,
        };
        formData = dispatchInfo;
      }
      return formData;
    },
    // 获取司机权益
    async queryMemberBenefits ({ carUserType, isChange }) {
      if (carUserType) {
        if (isChange) {
          const resMemberBenefits = await queryMemberBenefits({
            carUserType,
          });
          const formValue = resMemberBenefits.items[0];
          this.setSettlementData({
            dispatchBalanceType: `${formValue.settleType}`,
            dispatchReciveTime: formValue.receiptPeriod, // 回单期限天数
            dispatchReciveMonth: formValue.receiptPeriod, // 回单期限第几个月
            dispatchReciveTimeDay: formValue.receiptPeriodDay, // 回单期限第几号
            dispatchCollectionTime: formValue.payPeriod, // 收款期限天数
            dispatchCollectionMonth: formValue.payPeriod, // 收款期限第几个月
            dispatchCollectionTimeDay: formValue.payPeriodDay, // 收款期限第几号
          });
        }
      }
    },
    setDetailData (data) {
      this.setFormHide();
      if (data.costPaymentDaysInfo) {
        data.dispatchBalanceType = `${data.costPaymentDaysInfo.balanceType || '-1'}`;
        data.dispatchReciveTime = data.costPaymentDaysInfo.reciveTime || '0';
        data.dispatchReciveMonth = data.costPaymentDaysInfo.reciveMonth || '0';
        data.dispatchReciveTimeDay = data.costPaymentDaysInfo.reciveDay || '0';
        data.dispatchCollectionTime = data.costPaymentDaysInfo.collectionTime || '0';
        data.dispatchCollectionMonth = data.costPaymentDaysInfo.collectionMonth || '0';
        data.dispatchCollectionTimeDay = data.costPaymentDaysInfo.collectionDay || '0';
      }
    },
    setFormHide () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['dispatchRecive', 'dispatchCollection'],
      });
    },
    setSettlementData (options) {
      this.$refs.baseForm.setVal('dispatchBalanceType', options.dispatchBalanceType);
      this.otherFormData = {
        // 回单期限天数
        dispatchReciveTime: options.dispatchReciveTime || '0',
        // 回单期限第几个月
        dispatchReciveMonth: options.dispatchReciveMonth || '0',
        // 回单期限第几号
        dispatchReciveTimeDay: options.dispatchReciveTimeDay || '0',
        // 收款期限天数
        dispatchCollectionTime: options.dispatchCollectionTime || '0',
        // 收款期限第几个月
        dispatchCollectionMonth: options.dispatchCollectionMonth || '0',
        // 收款期限第几号
        dispatchCollectionTimeDay: options.dispatchCollectionTimeDay || '0',
      };
      this.handleLabelTypeChange();
    },
    init (data = {}) {
      this.setDetailData(data);
      this.setSettlementData({
        dispatchBalanceType: data ? data.dispatchBalanceType : '2',
        dispatchReciveTime: data ? data.dispatchReciveTime : '',
        dispatchReciveMonth: data ? (data.dispatchReciveMonth || data.dispatchReciveTime) : '',
        dispatchReciveTimeDay: data ? (data.dispatchReciveTimeDay || data.dispatchReciveTimeDay) : '',
        dispatchCollectionTime: data ? data.dispatchCollectionTime : '',
        dispatchCollectionMonth: data ? (data.dispatchCollectionMonth || data.dispatchCollectionTime) : '',
        dispatchCollectionTimeDay: data ? (data.dispatchCollectionTimeDay || data.dispatchCollectionTimeDay) : '',
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
